import axios from '@/plugins/axios'

let cacheData = {}

const cache = {
  getData (url, param) {
    return new Promise((resolve) => {
      let data = cacheData[`${url}+${JSON.stringify(param)}`]
      if (data) {
        resolve(data)
      } else {
        axios.get(`${url}`, {params: param})
          .then(res => {
            cacheData[`${url}+${JSON.stringify(param)}`] = res.data
            resolve(res.data)
          })
      }
    })
  },
  getDateWithNoparma (url) {
    return new Promise((resolve) => {
      let data = cacheData[`${url}`]
      if (data) {
        resolve(data)
      } else {
        axios.get(`${url}`)
          .then(res => {
            cacheData[`${url}`] = res.data
            resolve(res.data)
          })
      }
    })
  }
}

export default cache



// WEBPACK FOOTER //
// ./src/components/public/cache.js